/*
 * Fonts are bundled, not fetched.
 *
 * `@fontsource` ships the woff2 files and the `@font-face` rules, so the page
 * loads no third-party origin. The design package's `tokens/fonts.css` imports
 * both families from Google Fonts; that import is deliberately not carried
 * over — a marketing page for a service whose own documentation is this
 * careful about trust boundaries should not hand a visitor's IP address to a
 * third party to render a heading.
 *
 * Inter is the variable build, so weights 300–500 cost one file. The Arabic
 * family is loaded at the three weights the design actually uses.
 */
import '@fontsource-variable/inter';
import '@fontsource/ibm-plex-sans-arabic/300.css';
import '@fontsource/ibm-plex-sans-arabic/400.css';
import '@fontsource/ibm-plex-sans-arabic/500.css';
// Readex Pro carries the Arabic interface: one variable file, weights 160-700,
// SIL Open Font License. Plex Arabic stays as the fallback face.
import '@fontsource-variable/readex-pro';

import './styles/tokens.css';
import './styles/base.css';
import './styles/landing-workspace.css';
import './styles/workspace.css';
import './styles/authentication.css';
import './styles/merchant-workspace.css';
import './styles/business-profile.css';
import './styles/production-lines.css';
import './styles/taste-calibration.css';
import './styles/recommendation-reveal.css';
// The design layers load after every merchant stylesheet, so they restyle
// those surfaces without changing what they do.
import './styles/workspace-shell.css';
import './styles/merchant-design.css';
import './styles/pool-review.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App.js';

const container = document.getElementById('root');
if (!container) {
  throw new Error('The #root element is missing from index.html.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
